var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:{'shiftLightsDown' : _vm.isShifted}},[_c('ul',{staticClass:"lightrope"},_vm._l((_vm.lights),function(light,index){return _c('li',{key:index})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }